import { createReducer, on } from '@ngrx/store';
import { loadNextPage, loadNextPageFailure, loadNextPageSuccess } from '../actions/page.actions';
import { PageState } from '../models/assessment-models';

export const initialPageState: PageState = {
  page: {
    data: null,
    loading: false,
    error: null,
  },
};

export const pageReducer = createReducer(
  initialPageState,
  on(loadNextPage, (state, { nextPage }) => ({
    ...state,
    page: {
      data: nextPage,
      loading: true,
      error: null,
    },
  })),
  on(loadNextPageSuccess, (state, { pageToLoad }) => ({
    ...state,
    page: {
      data: pageToLoad,
      loading: false,
      error: null,
    },
  })),
  on(loadNextPageFailure, (state, { error }) => ({
    ...state,
    page: {
      data: null,
      loading: false,
      error,
    },
  })),
);
